import React, {Component} from 'react'
import {connect} from 'react-redux'
import SostaOnlineApiService from '../../../services/SostaOnlineApiService'
import Cart from "./Cart"
import {actions as cartActions} from '../../../redux/modules/Cart'
import {bindActionCreators} from "redux";
import moment from "moment";
import Loading from "../../../components/LoadingComponent";

const mapStateToProps = (state) => {
    return {
        cart: state.cart
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        cartActions: bindActionCreators(cartActions, dispatch)
    };
};

class CartContainer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            cartItems: [],
            loading: false,
            error: null
        };

        this.removeItem = this.removeItem.bind(this);
        this.addItemQuantity = this.addItemQuantity.bind(this);
        this.removeItemQuantity = this.removeItemQuantity.bind(this);
        this.onCheckoutClick = this.onCheckoutClick.bind(this);
        this.fetchCart = this.fetchCart.bind(this)
    }

    componentDidMount() {
        this.setState({loading: true});
        this.fetchCart();
    }

    fetchCart() {
        SostaOnlineApiService.fetchCart().then((data) => {
            this.setState({loading: false, cartItems: data.data});
        });
    }

    removeItem(item) {
        SostaOnlineApiService.deleteCartItem(item).then(result => this.fetchCart());
    }

    addItemQuantity(item) {
        if(item.quantity >= 99) {
            return;
        }

        SostaOnlineApiService.updateCartItem({
            id: item.id,
            quantity: item.quantity + 1,
        }).then((data) => this.fetchCart());
    }

    removeItemQuantity(item) {
        if(item.quantity <= 1) {
            return;
        }

        SostaOnlineApiService.updateCartItem({
            id: item.id,
            quantity: item.quantity - 1,
        }).then((data) => this.fetchCart());
    }

    onCheckoutClick() {
        this.props.history.push('/user-area/pay');
    }

    render() {

        if(this.state.loading) {
            return(<Loading/>)
        }

        if(this.state.error) {
            return(<div><h4 style={{color: 'red'}}>Errore nella visualizzazione del carrello</h4></div>);
        }

        return (<Cart
            onCheckoutClick={this.onCheckoutClick}
            removeItem={this.removeItem}
            addItemQuantity={this.addItemQuantity}
            removeItemQuantity={this.removeItemQuantity}
            items={this.state.cartItems} />);
    }
}

CartContainer.propTypes = {
};

export default connect(mapStateToProps, mapDispatchToProps)(CartContainer);




// WEBPACK FOOTER //
// ./src/containers/UserArea/Cart/CartContainer.js